<template>
    <div class="row">
        <form @submit.prevent="submit">
            <div class="col-md-6">
                <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                    <div class="panel panel-primary heading-border">
                        <div class="panel-heading">
                            <span class="panel-title">
                                <i class="fa fa-pencil-square"></i>
                                <span v-if="direction.id">Редактирование направления</span>
                                <span v-else>Добавление направления</span>
                            </span>
                        </div>
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Наименование</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.direction.name.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.direction.name.$error === true || forms.direction.errors.name" class="error">
                                        {{ this.forms.direction.errors.name ? this.forms.direction.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Схема оплаты</label>
                                    <label class="field select">
                                        <select v-model="$v.direction.salary_scheme_id.$model">
                                            <option disabled="">Выберите схему оплаты</option>
                                            <option
                                                    v-for="salaryScheme in data.salarySchemes"
                                                    v-bind:key="salaryScheme.id"
                                                    :value="salaryScheme.id"
                                            >
                                                {{salaryScheme.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.direction.salary_scheme_id.$error === true || forms.direction.errors.salary_scheme_id" class="error">
                                        {{ this.forms.direction.errors.salary_scheme_id ? this.forms.direction.errors.salary_scheme_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class=" section row">

                                <div class="col-md-6">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-direction-is-archive" v-model="$v.direction.isArchive.$model" value="1">
                                        <label for="form-direction-is-archive" data-on="Да" data-off="Нет"></label>
                                        <span>Архивный</span>
                                    </label>
                                </div>
                                <div class="col-md-6">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-direction-is-show-site" v-model="$v.direction.isShowSite.$model" value="1">
                                        <label for="form-direction-is-show-site" data-on="Да" data-off="Нет"></label>
                                        <span>Отображать на сайте</span>
                                    </label>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.direction.content.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.direction.isSubmitting">
                                <span v-if="direction.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="admin-form theme-primary tab-pane active" role="tabpanel">
                    <div class="panel panel-primary heading-border">
                        <div class="panel-heading">
                            <span class="panel-title">
                                <i class="fa fa-signal"></i>
                                Доступность
                            </span>
                        </div>
                        <div class="panel-body p25">

                            <div class="section row" v-for="show in data.shows" v-bind:key="show.id">
                                <div class="col-md-12">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" :id="'direction-show-' + show.id" v-model="direction.shows" v-bind:value="show">
                                        <label :for="'direction-show-' + show.id" data-on="Да" data-off="Нет"></label>
                                        <span>{{show.name}}</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import Direction from "../../models/Direction";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import DirectionShow from "../../models/DirectionShow";
    import DirectionSalaryScheme from "../../models/DirectionSalaryScheme";

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            if (to.params.id) {
                try {
                    let directionResponse, showsResponse, salarySchemeResponse;
                    [directionResponse, showsResponse, salarySchemeResponse] = await Promise.all([
                        Direction.get(to.params.id),

                        DirectionShow.getList(1, 999),

                        DirectionSalaryScheme.getList(1, 999, 'name'),
                    ]);

                    next(component => {
                        component.direction = directionResponse;
                        component.data.salarySchemes = salarySchemeResponse.data;
                        component.data.shows = showsResponse.data;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                let showsResponse, salarySchemeResponse;
                [showsResponse, salarySchemeResponse] = await Promise.all([

                    DirectionShow.getList(1, 999),

                    DirectionSalaryScheme.getList(1, 999, 'name'),
                ]);
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                    component.data.salarySchemes = salarySchemeResponse.data;
                    component.data.shows = showsResponse.data;
                });
            }
        },
        data() {
            return {
                data: {
                    shows: [],
                    salarySchemes: [],
                },
                direction: new Direction({
                    name: '',
                    salary_scheme_id: 0,
                    content: '',
                    isArchive: false,
                    isShowSite: false,
                    shows: [],
                }),
                forms: {
                    direction: {
                        isSubmitting: false,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            direction: {
                name: {required},
                salary_scheme_id: {},
                content: {},
                isArchive: {},
                isShowSite: {},
            },
        },
        methods: {
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.direction.isSubmitting = true;
                this.forms.direction.errors = {};

                if (this.direction.id) {

                    try {
                        await this.direction.update();
                    } catch (error) {
                        this.forms.direction.errors = error.errors;
                    }

                } else {

                    try {
                        let newDirection = await this.direction.add();

                        await this.$router.push({name: 'directions-edit', params: {id: newDirection.id}});
                    } catch (error) {
                        this.forms.direction.errors = error.errors;
                    }

                }

                this.forms.direction.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Направления - ' + (this.direction.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
